import { Wine } from 'lucide-react';
import InventoryMaster from './InventoryMaster';

export default function BarMaster({ user }) {
  return (
    <InventoryMaster
      user={user}
      masterType="bar"
      apiPrefix="bar-master"
      superCategory="Liquor"
      userRole="bartender"
      title="Bar Master"
      Icon={Wine}
      iconColor="text-purple-600"
      emptyMessage="No approved liquor items found in Price Master"
    />
  );
}
